import { FC } from 'react';

import ExcipientLabelListing from 'components/main/ExcipientLabel';

const ExcipientLabel: FC = () => <ExcipientLabelListing />;

export default ExcipientLabel;
